import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

// const firebaseConfig = {
//   apiKey: window.ReactApp.Env.APP_ID,
//   authDomain: window.ReactApp.Env.AUTH_DOMAIN,
//   databaseURL: window.ReactApp.Env.DATABASE_URL,
//   projectId: window.ReactApp.Env.PROJECT_ID,
//   storageBucket: window.ReactApp.Env.STORAGE_BUCKET,
//   messagingSenderId: window.ReactApp.Env.MESSAGE_SENDER_ID,
//   appId: window.ReactApp.Env.APP_ID,
//   measurementId: window.ReactApp.Env.MEASUREMENT_ID
// };
const firebaseConfig = {
  apiKey: 'AIzaSyB0ZbAd3VuXkVf935MO_iyOpPiOUUB304Q',
  authDomain: 'artistic-home.firebaseapp.com',
  databaseURL: 'https://artistic-home.firebaseio.com',
  projectId: 'artistic-home',
  storageBucket: 'artistic-home.appspot.com',
  messagingSenderId: '457168524886',
  appId: '1:457168524886:web:60c67baa227374f509cdf7',
  measurementId: 'G-8NV9KM9S3J'
};

// Initialize FirebaseConfig
const FirebaseConfig = firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();

export default FirebaseConfig;
